<div class="setup-bar">
  <div class="setup-bar__row">
    <span class="setup-bar__label">
      Item fee setup
      @if (hasUnsavedSetupChanges) {
        <span class="setup-bar__badge">Unsaved Changes</span>
      }
    </span>

    <pdq-dropdown
      class="setup-bar__select"
      [options]="setupOptions"
      [sections]="setupSections"
      helpTextPosition="bottom"
      [defaultOption]="selectedSetupOption"
      (onChange)="selectSetup($event.value ? +$event.value : null)"></pdq-dropdown>

    @if (currentSetup) {
      <pdq-button
        pdqPopover
        variant="ghost"
        icon="dots_menu"
        size="small"
        ariaLabel="Setup actions"
        [popoverTemplate]="setupActions"
        [forcePosition]="'bottom_right'"
        [closeOnPopoverClick]="true"
        [closeOnClickOutside]="true"></pdq-button>
      <ng-template #setupActions>
        <pdq-popover-container [loading]="false" [actionList]="true">
          <div class="action-list">
            <pdq-option (onSelect)="rename()">Rename</pdq-option>
            <pdq-option (onSelect)="duplicate()">Duplicate as new</pdq-option>
            <pdq-option (onSelect)="detach()">Detach and edit locally</pdq-option>
            @if (hasUnsavedSetupChanges) {
              <pdq-option (onSelect)="discard()">Discard changes</pdq-option>
            }
            <pdq-option variant="danger" (onSelect)="remove()">Delete setup</pdq-option>
          </div>
        </pdq-popover-container>
      </ng-template>

      <pdq-button
        label="Save Changes"
        variant="primary"
        [disabled]="busy || rulesInvalid || !hasUnsavedSetupChanges"
        (onClick)="saveChanges()"></pdq-button>
    }

    <pdq-button
      label="Save As New Setup"
      variant="secondary"
      [disabled]="busy || rulesInvalid"
      (onClick)="duplicate()"></pdq-button>
  </div>

  @if (currentSetup && otherMethodCount > 0) {
    <pdq-banner
      class="setup-bar__banner"
      variant="info"
      [inline]="true"
      [keepBkColor]="true"
      [closable]="false"
      [bannerTitle]="sharedSetupNotice"></pdq-banner>
  }

  @if (errorMessage) {
    <div class="setup-bar__error">{{ errorMessage }}</div>
  }
</div>
